import {DataStoreAbstract} from "../../shared/services/DataStoreAbstract";

export class DataStore extends DataStoreAbstract {

    getUser(): any {
        return null;
    }
}
